import React, { useState } from 'react';
import FillInTheGapsExercise from './FillInTheGapsExercise';
import './FillInTheGapsExerciseBoard.css';

const FILL_IN_THE_GAPS_ICON = (
  <span style={{
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 48, height: 48, borderRadius: 12, background: 'linear-gradient(135deg, #667eea 0%, #8a2be2 100%)', marginRight: 20
  }}>
    <svg width="28" height="28" viewBox="0 0 16 16" fill="white">
      <path d="M6 1v3H1V1zM1 0a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zm14 12v3h-5v-3zm-5-1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1zM6 8v7H1V8zM1 7a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1zm14-6v7h-5V1zm-5-1a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1z"/>
    </svg>
  </span>
);

const FillInTheGapsExerciseBoard = ({
  exerciseData, exerciseType: _exerciseType, onUpdate, isSelected, onSelect, onExpand,
  isExpanded: isExpandedProp, onClose,
  isStudent = false, myState = {}, otherState = {}, updateState = () => {},
}) => {
  const [isExpandedLocal, setIsExpandedLocal] = useState(false);
  const isExpanded = isExpandedProp !== undefined ? isExpandedProp : isExpandedLocal;
  const { sentences, title, level } = exerciseData;

  if (!sentences || !Array.isArray(sentences)) {
    return (
      <div className="fill-in-the-gaps-board-error">
        <p>Error: Invalid Fill in the Gaps exercise data</p>
      </div>
    );
  }

  return (
    <div className="fill-in-the-gaps-exercise-board">
      {!isExpanded ? (
        <div
          className={`fill-in-the-gaps-preview unified-exercise-preview fitg-board-card${isSelected ? ' is-selected' : ''}`}
          onClick={() => {
            if (isExpandedProp === undefined) setIsExpandedLocal(true);
            if (onSelect) onSelect();
            if (onExpand) onExpand();
          }}
        >
          {FILL_IN_THE_GAPS_ICON}
          <div className="unified-preview-main">
            <div className="unified-preview-title">{title || 'Fill in the Gaps Exercise'}</div>
            <div className="unified-preview-meta">
              {sentences.length} sentences · Level: {level || 'B1'}
            </div>
          </div>
          <button className="unified-preview-btn">
            Start Exercise
          </button>
        </div>
      ) : (
        <div className="fill-in-the-gaps-expanded">
          <FillInTheGapsExercise
            sentences={sentences}
            title={title}
            level={level}
            onClose={() => { if (isExpandedProp === undefined) setIsExpandedLocal(false); if (onClose) onClose(); }}
            onUpdate={onUpdate}
            isBoard={true}
            isStudent={isStudent}
            myState={myState}
            otherState={otherState}
            updateState={updateState}
          />
        </div>
      )}
    </div>
  );
};

export default FillInTheGapsExerciseBoard; 